module.exports = __webpack_public_path__ + "static/media/number.af3f9a06.svg";